import { render, staticRenderFns } from "./BuildSidebar.vue?vue&type=template&id=c6749164"
import script from "./BuildSidebar.vue?vue&type=script&lang=js"
export * from "./BuildSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports